import axios from "axios";
import getConfig from "../config/config";
import { Config } from "../config/configTypes";

let appConfig: Config | null = null;

export const initConfig = async () => {
  appConfig = await getConfig();

  axios.defaults.baseURL = appConfig.api.API_URL;
  axios.defaults.withCredentials = false;
  axios.defaults.headers.common["Access-Control-Allow-Private-Network"] =
    "true";
  axios.defaults.headers.post["Content-Type"] = "application/json";

  const authUserToken: any = sessionStorage.getItem("authUser");
  if (authUserToken) {
    axios.defaults.headers.common["Authorization"] =
      "Bearer " + authUserToken.replace(/"/g, "");
  }

  // axios interceptors
  axios.interceptors.response.use(
    function (response) {
      return response.data ? response.data : response;
    },
    function (error) {
      let message;
      switch (error?.response?.status) {
        case 500:
          message = "Internal Server Error";
          break;
        case 403:
          sessionStorage.removeItem("authUser");
          window.location.reload();
          break;
        case 404:
          message = "Sorry! the data you are looking for could not be found";
          break;
        case 409:
          message =
            "We regret to inform you that your account has been suspended. Please contact the support team.";
          break;
        default:
          message = error.message || error;
      }
      error.customMessage = message;
      return Promise.reject(error);
    }
  );

  return appConfig;
};

export const getAppConfig = (): Config => {
  if (!appConfig) {
    throw new Error(
      "Config has not been initialized yet. Call initConfig() first."
    );
  }
  return appConfig;
};

export const setAuthorization = (token: string | null) => {
  if (token) {
    axios.defaults.headers.common["Authorization"] =
      "Bearer " + token.replace(/"/g, "");
  } else {
    delete axios.defaults.headers.common["Authorization"];
  }
};
